// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"65c7ae06","171":"3514644c"}[chunkId] + ".chunk.css";
};